






import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import * as api from '@/api';
import * as models from '@/api/models';
import UserModule from '@/store/modules/user';

/** 退出登录 */
@Component({})
export default class Logout extends Vue {
  loading = true;

  async mounted() {
    await UserModule.LogOut();
    location.href = '#/';
  }
}
